import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { changeEmailCompletionMessage } from '../../../../message';
import { usePutUserEmailMutation } from '../../../../api/userApi';
import { logger } from '../../../../services/logger';

function ApproveToken() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [putUserEmail] = usePutUserEmailMutation();

  // トークンを使ってメールアドレスの変更を完了させる
  useDidMount(() => {
    // URL からトークンを取得する
    const token = searchParams.get('token');

    putUserEmail({ emailResetToken: token ?? '' })
      .unwrap()
      .then(() => {
        // マイページ画面に成功メッセージ付きでリダイレクトする
        navigate(`/mypage?success=${changeEmailCompletionMessage}`, {
          replace: true,
        });
      })
      .catch(logger.error);
  });

  return null;
}

export default ApproveToken;

/**
 * コンポーネントがマウントされたときに処理を実行する
 * @param fn 実行する処理
 */
function useDidMount(fn: () => void) {
  const ref = useRef(false);
  useEffect(() => {
    if (ref.current) return;
    ref.current = true;
    fn();
  }, []);
}
